import {
  SelectedQuoteSummary,
  type SelectedQuoteSummaryProps,
} from "@/shared/components/SelectedQuoteSummary";
import { LOCALISATION_PROFILE } from "@/shared/config/localisation";

type SelectedCarQuoteSummaryProps = Omit<
  SelectedQuoteSummaryProps,
  "insuredValue" | "insuredValueLabel"
> & {
  carValue?: string | number | null;
};

export function SelectedCarQuoteSummary({ carValue, ...props }: SelectedCarQuoteSummaryProps) {
  return (
    <SelectedQuoteSummary
      {...props}
      insuredValue={carValue}
      insuredValueLabel={LOCALISATION_PROFILE.motor.vehicleValueSummaryLabel}
    />
  );
}
